import React from "react";

const resolveRowKey = (row, rowIndex, keyField) => {
  if (typeof keyField === "function") {
    return keyField(row, rowIndex);
  }

  if (row && row[keyField] !== undefined && row[keyField] !== null) {
    return row[keyField];
  }

  return rowIndex;
};

const DataTable = ({
  columns,
  data,
  keyField = "id",
  loading = false,
  loadingText = "Loading...",
  emptyText = "No records found.",
  className = "",
}) => {
  return (
    <div className={`ui-data-table-wrap ${className}`.trim()}>
      <table className="ui-data-table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key || column.label} className={column.headerClassName || ""}>
                {column.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan={columns.length} className="ui-data-table__state">
                {loadingText}
              </td>
            </tr>
          ) : data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="ui-data-table__state">
                {emptyText}
              </td>
            </tr>
          ) : (
            data.map((row, rowIndex) => (
              <tr key={resolveRowKey(row, rowIndex, keyField)}>
                {columns.map((column) => {
                  const cellValue = column.render
                    ? column.render(row, rowIndex)
                    : row[column.key] ?? "-";

                  return (
                    <td
                      key={`${column.key || column.label}-${rowIndex}`}
                      className={column.className || ""}
                      data-label={column.mobileLabel || column.label}
                    >
                      {cellValue}
                    </td>
                  );
                })}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
